<ng-container>
  <div class="form-horizontal">
    <h1 class="heading">Support
    </h1>
  </div>

</ng-container>
